import { css } from "styled-components";
import { Durations } from "@paclife/plds.tokens";

const FadeIn = css`
    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
    animation: fadeIn ${Durations.medium}s ease-in-out forwards;
`;

const FadeOut = css`
    @keyframes fadeOut {
        from {
            opacity: 1;
        }
        to {
            opacity: 0;
        }
    }
    animation: fadeOut ${Durations.medium}s ease-in-out forwards;
`;

export { FadeIn, FadeOut };
